import { createContext, useContext } from "react";
import { OwnershipSelection } from "../ownership.types";

/**
 * Lets edge labels (rendered in EdgeLabelRenderer portals, above the edge
 * SVG layer) drive selection — label clicks don't reach ReactFlow's
 * onEdgeClick. A label may select a single relationship or, for a collapsed
 * bundle, the whole payer → receiver bundle.
 */
export const EdgeSelectionContext = createContext<
    (selection: OwnershipSelection) => void
>(() => undefined);

export function useEdgeSelection(): (selection: OwnershipSelection) => void {
    return useContext(EdgeSelectionContext);
}
